import Api from './Api'

export default {
    GetAllOrders(payload) {
        return Api().post(`/kitchendisplay`, payload);
    },
    UpdateOrders(payload) {
        return Api().put(`/kitchendisplay`, payload);
    }
}


// WEBPACK FOOTER //
// ./src/services/KitchenService.js